import { useContext } from 'react';
import { ApplianceContext } from './ApplianceContext';

export const useAppliance = () => useContext(ApplianceContext);
